import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from './languages/en.json'
import tr from './languages/tr.json'
import uz from './languages/uz.json'
import ru from './languages/ru.json'

import { LocalStorageService } from "../service/local-storage-service";

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        // the translations
        // (tip move them in a JSON file and import them,
        // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
        resources: {
            tr: {
                translation: tr
            },
            en: {
                translation: en
            },
            uz: {
                translation: uz
            },
            ru: {
                translation: ru
            }
        },
        lng: LocalStorageService.getLanguage(getBrowserLang()), // if you're using a language detector, do not define the lng option
        fallbackLng: LocalStorageService.getLanguage(getBrowserLang()),

        interpolation: {
            escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        }
    });

function getBrowserLang() {
    const browserLang = navigator.language || navigator.userLanguage;
    const langCode = browserLang ? browserLang.split('-')[0] : 'tr';

    const supported = ['tr', 'en', 'uz', 'ru'];
    return supported.includes(langCode) ? langCode : 'tr';
}

/**
 * <html lang> seçili dile bağlanır. Eksik/yanlış lang iki soruna yol açıyordu:
 *   1) Chrome sayfanın dilini içerikten tahmin ediyor, Türkçe sayfayı yabancı dil sanıp
 *      "çevireyim mi?" çubuğunu açıyordu — tarayıcı dili de Türkçe olmasına rağmen.
 *   2) CSS text-transform: uppercase dönüşümü DİLE GÖRE yapılır. lang Türkçe değilken
 *      "istanbul" → "ISTANBUL" oluyor; doğrusu "İSTANBUL" (noktalı İ kayboluyordu).
 *
 * Kaynak i18next: dil çalışma anında değişirse (dil menüsü) lang da anında güncellenir,
 * sayfa yenilemeye gerek kalmaz.
 */
const syncHtmlLang = (lng) => {
    document.documentElement.lang = (lng || 'tr').split('-')[0];
};

syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);
